import {
  StyledSelect
} from "./chunk-RWT4HETL.mjs";

// src/components/select/select-value-text.tsx
import { Select } from "@ark-ui/react";
import React, { forwardRef } from "react";
var SelectValueText = forwardRef(function SelectValueText2({ placeholder, children, ...rest }, ref) {
  return /* @__PURE__ */ React.createElement(StyledSelect.ValueText, { ref, ...rest }, /* @__PURE__ */ React.createElement(Select.Context, null, (select) => {
    const items = select.selectedItems;
    if (items.length === 0) return placeholder;
    if (children) return children(items);
    if (items.length === 1)
      return select.collection.stringifyItem(items[0]);
    return `Select (${items.length})`;
  }));
});

export {
  SelectValueText
};
